import { call, put, takeLatest } from 'redux-saga/effects';
import { getMetrics } from 'api/ReportingAPI';
import { addToRootSaga } from 'store';
import * as actions from './actions';
import * as actionTypes from './actionTypes';

export function* fetchMetrics() {
  try {
    const { data } = yield call(getMetrics);
    yield put(actions.fetchMetricsResponse(data));
  } catch (error) {
    yield put(actions.fetchMetricsError(error));
  }
}

addToRootSaga([takeLatest(actionTypes.FETCH_METRICS_REQUEST, fetchMetrics)]);
